
import { computed, defineComponent, PropType, reactive } from 'vue'

import TheButton from '@/common/components/UI/TheButton/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'

import {
    MonitoringFilteredCourierStatistics,
    MonitoringFilteredStatistics,
} from '@/new-services/types/monitoring'

export default defineComponent({
    name: 'monitoring-stats',
    components: { TheButton, Loader },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        failed: {
            type: Boolean,
            default: false,
        },
        errorText: {
            type: String,
            default: 'Произошла ошибка',
        },
        emptyText: {
            type: String,
            default: 'Нет данных',
        },
        img: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
        statistics: {
            type: Array as PropType<MonitoringFilteredStatistics>,
            default: () => [],
        },
        statisticsCouriers: {
            type: Array as PropType<MonitoringFilteredCourierStatistics>,
            default: () => [],
        },
        isDelivery: {
            type: Boolean,
            default: false,
        },
        isCouriers: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['reload'],
    setup(props, { emit }) {
        const state = reactive({
            is_opened: false,
        })

        const emitReload = () => {
            if (props.loading) return
            emit('reload')
        }

        const toggleSectors = () => {
            if (!isCanExpand.value) return
            state.is_opened = !state.is_opened
        }

        const isCanExpand = computed(() => {
            if (props.statisticsCouriers.length === 0 || props.statistics.length === 0) {
                return true
            }

            return false
        })

        const total = computed(() => {
            if (props.isCouriers) {
                return props.statisticsCouriers.length
            }

            let temp_sum = 0

            props.statistics.forEach((statistics_row) => {
                temp_sum += statistics_row.total
            })

            return temp_sum
        })

        const totalCompleted = computed(() => {
            if (props.isCouriers) {
                let sum_delivery = 0,
                    sum_take = 0

                props.statisticsCouriers.forEach((statistics_row) => {
                    sum_delivery += statistics_row.completedDeliveries
                    sum_take += statistics_row.completedTakes
                })

                return `${sum_take} / ${sum_delivery}`
            }

            let temp_sum = 0

            props.statistics.forEach((statistics_row) => {
                temp_sum += statistics_row.completed
            })

            return temp_sum
        })

        const totalRemained = computed(() => {
            if (props.isCouriers) {
                let sum_delivery = 0,
                    sum_take = 0

                props.statisticsCouriers.forEach((statistics_row) => {
                    sum_delivery += statistics_row.remainedDeliveries
                    sum_take += statistics_row.remainedTakes
                })

                return `${sum_take} / ${sum_delivery}`
            }

            let temp_sum = 0

            props.statistics.forEach((statistics_row) => {
                temp_sum += statistics_row.remained
            })

            return temp_sum
        })

        const totalCancelled = computed(() => {
            if (props.isCouriers) {
                let sum_delivery = 0,
                    sum_take = 0

                props.statisticsCouriers.forEach((statistics_row) => {
                    sum_delivery += statistics_row.cancelledDeliveries
                    sum_take += statistics_row.cancelledTakes
                })

                return `${sum_take} / ${sum_delivery}`
            }

            let temp_sum = 0

            props.statistics.forEach((statistics_row) => {
                temp_sum += statistics_row.cancelled
            })

            return temp_sum
        })

        const getStatistics = computed(() => {
            if (props.isCouriers) {
                const statistics_sorted: MonitoringFilteredCourierStatistics = [
                    ...props.statisticsCouriers,
                ]

                return statistics_sorted.sort(
                    (s_1, s_2) =>
                        s_2.totalDeliveries +
                        s_2.totalTakes -
                        (s_1.totalDeliveries + s_1.totalTakes)
                )
            } else {
                const statistics_sorted = [...props.statistics]
                return statistics_sorted.sort((s_1, s_2) => s_2.total - s_1.total)
            }
        })

        return {
            state,
            emitReload,
            toggleSectors,
            isCanExpand,
            total,
            totalCompleted,
            totalRemained,
            totalCancelled,
            getStatistics,
        }
    },
})
